import React, {Component, ReactElement} from 'react'
import {StyledSecondaryButton} from '../../../styledComponents/Button'
import styled from 'styled-components'
import {Colors, FontSize, FontWeights} from '../../../styledComponents/Constants'
import {createResidentPage, ResidentPagePropsSet} from '../../../components/shared/hoc/createResidentPage'
import {ColumnFlexContainer} from '../../../styledComponents/FlexComponents'
import {BlockSpacer} from '../../../styledComponents/ResponsiveConvenience'
import {Box} from '@mui/material'
import {Location} from 'react-router-dom'

interface Props {
    location: Location
}

class NatResidentHasekoIdLinkCompletePage extends Component<Props & ResidentPagePropsSet> {
    constructor(props: Props & ResidentPagePropsSet) {
        super(props)
        this.handleTopButtonClick = this.handleTopButtonClick.bind(this)
    }

    // Top画面
    handleTopButtonClick(): void {
        this.props.navigate(
            `/resident/mypage`,
        )
    }

    render(): ReactElement {
        return (<>
            <ColumnFlexContainer>
                <BlockSpacer height={'60px'}/>
                <img src={'/resources/images/icons/icon_reserve_complete.svg'} width={'120px'} alt={'complete'}/>
                <BlockSpacer height={'20px'}/>
                <CompleteMessage>長谷工ID登録が完了しました</CompleteMessage>
                <Box height={'5px'}/>
                <div>詳細はメールにてご確認ください</div>
            </ColumnFlexContainer>
            <BlockSpacer height={'60px'}/>
            <StyledSecondaryButton onClick={this.handleTopButtonClick}>
                素敵ネットTOPへ
            </StyledSecondaryButton>
            <BlockSpacer height={'30px'}/>
        </>)
    }
}

export default createResidentPage(NatResidentHasekoIdLinkCompletePage)

const CompleteMessage = styled.div`
  font-size: ${FontSize.Big};
  font-weight: ${FontWeights.Bold};
  color: ${Colors.AccentDark};
`
